import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import cookie from "js-cookie";

import Loader from "common/Loader";
import { SUGGESTION_SOURCE } from "lib/constants";
import { staticURL } from "lib/img";
import rollbar from "lib/rollbar";
import { addSavedPosition } from "lib/util";
import { positionsFetchSuggestions } from "redux/positions/actions";

import SuggestionView from "js/views/suggestion";
import initJobList from "js/views/job-list";

const mapStateToProps = ({ suggestions, ws }) => ({
    suggestions: suggestions.positions,
    group: suggestions.group,
    loading: ws.ui.loading,
});

class OnboardSuggestions extends React.PureComponent {
    static propTypes = {
        group: PropTypes.string.isRequired,
        loading: PropTypes.bool.isRequired,
        positionsFetchSuggestions: PropTypes.func.isRequired,
        suggestions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    };

    state = {
        loaded: false,
        approved: null,
        suggestionCount: 0,
    };

    componentDidMount() {
        this.props.positionsFetchSuggestions();
    }

    componentDidUpdate({ suggestions }) {
        if (suggestions !== this.props.suggestions) {
            if (this.props.suggestions.length === 0) {
                setTimeout(() => {
                    window.location.href = "/profile/";
                }, 0);
                return;
            }

            initJobList();

            this.view = new SuggestionView({
                el: this.container,
                group: this.props.group,
                positions: this.props.suggestions,
                source: SUGGESTION_SOURCE.ONBOARD,
            });
            this.view.render();

            this.view.on("suggest:finish", this.onSuggestFinish);
            this.view.on("suggest:approve", addSavedPosition);
            rollbar.info("Onboarding started");

            /* eslint-disable react/no-did-update-set-state */
            this.setState({
                loaded: true,
                suggestionCount: this.props.suggestions.length,
            });
            /* eslint-enable */
        }
    }

    onSuggestFinish = (approved, current) => {
        cookie.set("_skip_ws_suggest", 1, { expires: 1 });
        rollbar.info("Onboarding finished", {
            viewed: current,
            approved: approved.length,
        });

        this.setState({ approved });
    };

    renderLoader() {
        if (!this.props.loading) {
            return null;
        }

        return <Loader />;
    }

    renderIntro() {
        const { loaded, suggestionCount } = this.state;
        if (!loaded) {
            return null;
        }

        const s = suggestionCount > 1 ? "s" : "";

        return (
            <header className="suggestions__intro">
                <h1>Your profile is all set up!</h1>
                <p>
                    Based on what you&apos;ve just told us, we found {suggestionCount} job{s} you
                    may be interested in. You can review them below or skip ahead to your profile.
                </p>
                <div className="suggestions__intro-skip">
                    <a href="/profile/">Skip to profile &rsaquo;</a>
                </div>
            </header>
        );
    }

    renderFinish() {
        const { approved } = this.state;
        if (!approved) {
            return null;
        }

        if (approved.length === 0) {
            return (
                <div className="suggestions__empty">
                    <img src={staticURL("no-selections-illo.svg")} alt="No selections" />
                    <p>That&apos;s all our suggestions for now</p>
                    <a href="/profile/" className="btn btn-large btn-primary">
                        Skip to profile
                    </a>
                </div>
            );
        }

        const count = approved.length;
        const s = count > 1 ? "s" : "";
        const pronoun = count > 1 ? "them" : "it";

        return (
            <div className="suggestions__empty">
                <img src={staticURL("illo-briefcase.svg")} alt="briefcase" />
                <p className="suggestions__empty-header">
                    You saved {count} job{s}. Do you want to apply to {pronoun} now?
                </p>
                <a
                    href={`/app/start/?sn=0&p=${approved.join(",")}&utm_medium=ws-onboard`}
                    className="btn btn-primary btn-large"
                >
                    Apply Now
                </a>
            </div>
        );
    }

    renderSuggestions() {
        if (this.state.approved) {
            return null;
        }

        return <div ref={(c) => (this.container = c)} />;
    }

    render() {
        return (
            <div className="content onboard suggestions__root">
                {this.renderIntro()}
                {this.renderLoader()}
                {this.renderFinish()}
                {this.renderSuggestions()}
            </div>
        );
    }
}

export default connect(mapStateToProps, { positionsFetchSuggestions })(OnboardSuggestions);
